import { render, staticRenderFns } from "./QuotationCreateView.vue?vue&type=template&id=0b91a9f6"
import script from "./QuotationCreateView.vue?vue&type=script&lang=js"
export * from "./QuotationCreateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports